import { cloneDeep } from 'lodash';
import { useEffect, useState } from 'react';
import { MainTab } from '../tabs/MainTab';
import { ChartRenderer } from './ChartRenderer';

interface TabViewProps {
  tabData: any;
}

export const TabView = ({ tabData }: TabViewProps) => {
  const [tabItems, setTabItems] = useState([]);

  useEffect(() => {
    if (tabData.length > 0) {
      let tabEl = document.querySelectorAll('button[data-bs-toggle="tab"]');

      tabEl.forEach((i, j) => {
        i.addEventListener('shown.bs.tab', function (event) {
          let activeTab = event.target as HTMLElement;
          renderTabContent(activeTab.innerHTML);
        });
      });

      let cloneData = cloneDeep(tabData);

      cloneData.map((i: any, j: number) => {
        if (j === 0) {
          i.content = <ChartRenderer chartType={i.data[0].vizType} chartData={i.data} />;
        }
      });

      setTabItems(cloneData);
    }
  }, [tabData]);

  const renderTabContent = (tab: string) => {
    let cloneData = cloneDeep(tabData);

    cloneData.map((i: any, j: number) => {
      if (i.name === tab) {
        i.content = <ChartRenderer chartType={i.data[0].vizType} chartData={i.data} />;
      }
    });

    setTabItems(cloneData);
  };

  return (
    <div className="col-12">
      <div className="mt-4 position-relative">
        <MainTab tabItems={tabItems.length > 0 ? tabItems : tabData} />
      </div>
    </div>
  );
};
